module.exports = __webpack_public_path__ + "static/img/yurou.65dc6e74.png";